var gallery = {
    init: function() {

        var self = this;

		self.createTinySlider();
		self.changeMainPhoto();
    },
    createTinySlider: function () {

		if( ! jQuery( '.js-slideGallery-slider' ) ) {
			return;
		}

		jQuery('.js-slideGallery-slider').not('.slick-initialized').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			speed: 0,
			swipeToSlide: false,
			swipe: false,
			arrows: false,
			dots: true,
			appendDots: jQuery('.js-slideGallery-dots'),
		});

		jQuery(document).on("click", ".js-slideGallery-slider .slick-current" , function() {
			jQuery('.js-slideGallery-slider').slick('slickPrev');
		});
		jQuery(document).on("click", ".js-slideGallery-slider .slick-active +  .slick-active + .slick-active" , function() {
			jQuery('.js-slideGallery-slider').slick('slickNext');
		});
	},
	photosChange: function () {
		var newPhotoLink = jQuery( '.js-slideGallery-slider' ).find(".slick-current + .slick-active .slider-gallery__one").data('img');
		var oldPhotoLink = jQuery( '.js-slideGallery-new image' ).attr('xlink:href');

		// console.log( newPhotoLink );

		jQuery( '.js-slideGallery-old' ).attr('src', oldPhotoLink);
		jQuery( '.js-slideGallery-new' ).removeClass("animate");
		jQuery( '.js-slideGallery-new image' ).attr('xlink:href', newPhotoLink);
		
		setTimeout(function() {
			jQuery( '.js-slideGallery-new' ).addClass("animate");
		}, 100);
	},
	changeMainPhoto: function () {
		gallery.photosChange();

		jQuery('.js-slideGallery-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
			gallery.photosChange();
		});
	},
	
}

export {
    gallery
};	